import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from '@custom-components/general/card/card.component';
import { LinkButtonComponent } from '@custom-components/general/button';
import { ListRowComponent } from '@custom-components/general/list-row';
import { NoItemsFoundComponent } from '@custom-components/general/no-items-found/no-items-found.component';
import { TablePaginationComponent } from '@custom-components/general/table-pagination/table-pagination.component';
import { TagComponent } from '@custom-components/general/tag/tag.component';
import { InstallationStatus } from '@core/models';

export interface GroupInstallationRow {
  installationOid: string;
  name: string;
  status: InstallationStatus;
  address: string;
  partnerName: string;
  ownedByOtherPartner: boolean;
  locationId: number;
  viaDeviceId: number | null;
  viaDeviceLabel: string;
}

@Component({
  selector: 'xemex-group-installations',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    CardComponent,
    LinkButtonComponent,
    ListRowComponent,
    NoItemsFoundComponent,
    TablePaginationComponent,
    TagComponent,
  ],
  templateUrl: './group-installations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupInstallationsComponent {
  rows = input.required<GroupInstallationRow[]>();
  total = input.required<number>();
  page = input.required<number>();
  pageSize = input.required<number>();
  loading = input<boolean>(false);

  pageChange = output<number>();
  viewInstallation = output<string>();
  viewDevice = output<number>();
  viewLocation = output<number>();

  protected readonly totalPages = computed(() =>
    Math.max(1, Math.ceil(this.total() / this.pageSize())),
  );

  // The row itself opens the installation, so a link inside it must not bubble up to the row.
  protected onViewDevice(deviceId: number, event: MouseEvent): void {
    event.stopPropagation();
    this.viewDevice.emit(deviceId);
  }

  protected onViewLocation(locationId: number, event: MouseEvent): void {
    event.stopPropagation();
    this.viewLocation.emit(locationId);
  }
}
